import {getRouteByPathname, MRAppRoutes} from './routes';

export const titles = {
  [MRAppRoutes.ROOT]: '',
  [MRAppRoutes.ADMIN]: '',

  [MRAppRoutes.MODEL_UPLOAD]: 'Add Model Entry',

  [MRAppRoutes.MODEL_LIST]: 'Model List',
  [MRAppRoutes.MODEL_DETAIL]: 'Model Detail',

  [MRAppRoutes.SUBMODEL_LIST]: 'SubModel List',

  [MRAppRoutes.VISUALIZATION_STEP_1]: 'Visualization - Scenario selection',
  [MRAppRoutes.VISUALIZATION_STEP_2]: 'Visualization - Reordering and setting',
  [MRAppRoutes.VISUALIZATION_STEP_3]: 'Visualization - Dynamic data visualization',
  [MRAppRoutes.VISUALIZATION_PARAMETERS_DISPLAY]: 'Visualization - Parameters display',

  [MRAppRoutes.MODEL_INPUT_LIST]: 'Input Definition List',
  [MRAppRoutes.MODEL_INPUT_EDITOR]: 'Input Definition Editor',

  [MRAppRoutes.FILTER_PAGE]: 'Filter',

  [MRAppRoutes.SCENARIO_LIST]: 'Scenario List',
  [MRAppRoutes.SCENARIO_DETAIL]: 'Scenario Detail',
  [MRAppRoutes.SCENARIO_PARAMETERS_VIEW]: 'Model Instance View',
  [MRAppRoutes.SCENARIO_PARAMETERS_EDITOR]: 'Scenario Parameters Editor',

  [MRAppRoutes.SCENARIO_EXECUTION_QUEUE]: 'Scenario - Execution Queue',
  [MRAppRoutes.EXTERNALIZATION]: 'External Users Tab',
  [MRAppRoutes.EXTERNALIZATION_LIST]: 'Externalization',
  [MRAppRoutes.EXTERNALIZATION_ENROLL]: 'External - User Enroll',

  [MRAppRoutes.USER_LIST]: 'User List',
  [MRAppRoutes.USER_ENROLL]: 'User Enroll',
  [MRAppRoutes.USER_DETAIL]: 'User Detail',
  [MRAppRoutes.USER_EDIT]: 'Edit User',

  [MRAppRoutes.MANAGE_METADATA]: 'Manage Metadata',
  [MRAppRoutes.MANAGE_METADATA_PROPERTY]: 'Manage Metadata',

  [MRAppRoutes.INCIDENT_MANAGEMENT]: 'Incident Management',

  [MRAppRoutes.ADMIN_EXTERNALIZATION_LIST]: 'External Users',
  [MRAppRoutes.REGISTRATION_REVIEW]: 'External User review',
  [MRAppRoutes.USER_REGISTRATION]: 'External User registration',
  [MRAppRoutes.LANDING_PAGE]: 'Landing Page',

  [MRAppRoutes.ALL_NOTIFICATIONS]: 'All Notification',

  [MRAppRoutes.NOT_IMPLEMENTED]: '',
};

export const getTitleByPathname = (pathname: string): string => {
  const route = getRouteByPathname(pathname);

  // Special handling for MODEL_UPLOAD to differentiate between add and edit
  if (route === MRAppRoutes.MODEL_UPLOAD) {
    // Check for uuid query parameter in multiple places
    // 1. Try window.location.search (standard query params)
    // 2. Try window.location.hash (hash-based routing with query params)
    let hasUuid = false;

    try {
      // Check in standard search params
      const searchParams = new URLSearchParams(window.location.search);
      hasUuid = searchParams.has('uuid');

      // If not found, check in hash (for hash-based routing)
      if (!hasUuid && window.location.hash) {
        const hashSearch = window.location.hash.split('?')[1];
        if (hashSearch) {
          const hashParams = new URLSearchParams(hashSearch);
          hasUuid = hashParams.has('uuid');
        }
      }
    } catch (e) {
      // Silently fail if window is not available (SSR context)
      hasUuid = false;
    }

    const part = hasUuid ? 'Edit Model Entry' : 'Add Model Entry';
    return `${part} - Model Repository`;
  }

  const part = titles[route as keyof typeof titles] || '';
  const pathName = `${part} - `;
  return `${part !== '' ? pathName : ''}Model Repository`;
};
